import { User } from 'common/types/user.type';
import { roles } from './common';
import { UserSort } from '../types';

const sortUsers = (order: UserSort, items: User[]) => {
  const callBack = getSortCallback(order as unknown as UserSort);
  return items.sort(callBack);
};

function getSortCallback(sort: UserSort): (userA: User, userB: User) => number {
  return (userA: User, userB: User) => {
    const result = sortDescending(userA, userB, sort.sortBy);
    return sort.sortDir === 'desc' ? result : result * -1;
  };
}

function sortDescending(userA: User, userB: User, key: UserSort['sortBy']) {
  if (typeof key !== 'string') {
    return 0;
  }

  if (key === 'company') {
    const companyA = userA.company?.name;
    const companyB = userB.company?.name;
    return String(companyA).localeCompare(String(companyB), undefined, { sensitivity: 'base' });
  }

  if (key !== 'role') {
    return String(userA[key]).localeCompare(String(userB[key]), undefined, { sensitivity: 'base' });
  }

  const roleA = roles.findIndex((role) => role === userA.role);
  const roleB = roles.findIndex((role) => role === userB.role);
  if (roleB < roleA) return -1;
  if (roleB > roleA) return 1;
  return 0;
}

export default sortUsers;
